import { Component, Input, Optional, Self, ChangeDetectorRef } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

// TODO selector must be the same as file name. Two concepts for 'field' in the app?
@Component({
    selector: 'multi-field',
    providers: [],

    templateUrl: './field.component.html',
    styleUrls: ['./field.component.scss']
})
export class MultiFieldComponent implements ControlValueAccessor {
    @Input() placeholder = 'Enter your value here';
    @Input() fieldType: FieldType;
    @Input() fieldName: string;
    @Input() readonly: boolean;
    @Input() appearance = 'outline';
    @Input() floatLabel = 'always';

    val;
    dateTimeValue: Date;
    invalidChars = [
        '-',
        '+',
        'e',
    ];
    validationError: string = null;

    private readonly ALLOWED_PATTERN = /^[\p{L}\p{N}\s.,;:!?'"\-()/@#&+_=\[\]{}\$]*$/u;
    private readonly DANGEROUS_PATTERNS: RegExp[] = [
        /<script/i,
        /<\/script/i,
        /javascript:/i,
        /data:/i,
        /vbscript:/i,
        /\$\{/,
        /\$\(/,
        /`/,
        /\|\|/,
        /&&/,
        /;\s*--/,
        /union\s+select/i,
        /insert\s+into/i,
        /drop\s+table/i,
        /delete\s+from/i,
        /eval\s*\(/i,
        /exec\s*\(/i
    ];

    constructor(
        @Optional() @Self() public ngControl: NgControl,
        private changeDetector: ChangeDetectorRef
    ) {
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }

    get hasError(): boolean {
        return !!this.validationError;
    }

    get value() {
        return this.val;
    }

    set value(val) {
        // if (this.fieldType === FieldType.DATE) {
        //     this.dateTimeValue = new Date(this.val);
        // }
        this.val = val;
        this.onChange(val);
        this.onTouched();
    }

    onChange: any = () => {};

    onTouched: any = () => {};

    onKeydown(event) {
        if (this.invalidChars.includes(event.key)) {
            event.preventDefault();
        }
    }

    registerOnChange(fn) {
        this.onChange = fn;
    }

    registerOnTouched(fn) {
        this.onTouched = fn;
    }

    writeValue(value) {
        if (!value) {
            this.dateTimeValue = null;
            this.val = null;
            return;
        }

        this.dateTimeValue = new Date(value);
        this.value = value;
    }


    registerChange(value) {
        this.validateInput(value);
        this.value = value;
    }

    validateInput(value: string): void {
        if (!value || value.trim() === '') {
            this.validationError = null;
            this.changeDetector.markForCheck();
            return;
        }

        for (const pattern of this.DANGEROUS_PATTERNS) {
            if (pattern.test(value)) {
                this.validationError = 'This field contains invalid characters';
                this.changeDetector.markForCheck();
                return;
            }
        }

        if (!this.ALLOWED_PATTERN.test(value)) {
            this.validationError = 'This field contains invalid characters';
            this.changeDetector.markForCheck();
            return;
        }

        this.validationError = null;
        this.changeDetector.markForCheck();
    }

    registerDateChange() {
        this.value = this.convertDateToTimestamp(this.dateTimeValue);
    }

    convertDateToTimestamp(date) {
        return new Date(date).getTime();
    }
}

export enum FieldType {
    TEXT = 'SHORT_TEXT_FIELD',
    DATE = 'DATE_FIELD',
    NUMBER = 'NUMBER_FIELD',
}
